/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface LoginResponseDto
 */
export interface LoginResponseDto {

    /**
     * @type {string}
     * @memberof LoginResponseDto
     */
    accessToken: string;

    /**
     * @type {string}
     * @memberof LoginResponseDto
     */
    refreshToken: string;

    /**
     * @type {number}
     * @memberof LoginResponseDto
     */
    expireIn: number;

    /**
     * @type {number}
     * @memberof LoginResponseDto
     */
    refreshTokenExpireIn: number;

    /**
     * @type {any}
     * @memberof LoginResponseDto
     */
    tokenType: any;
}
